import { weddingConfig } from '@/data/weddingConfig';
import { weddingImages } from '@/data/weddingImages';
import WeddingImage from '@/components/base/WeddingImage';
import ScrollReveal from '@/components/feature/ScrollReveal';

export default function PhotoDivider() {
  const initials = [weddingConfig.brideName, weddingConfig.groomName]
    .map((n) => n.replace(/\[|\]/g, '').trim().charAt(0).toUpperCase())
    .filter(Boolean)
    .join(' · ');

  return (
    <section className="relative w-full">
      {/* Transition ornament bridging the information blocks into photography */}
      <div className="flex flex-col items-center gap-4 bg-background-100 py-8 md:py-10">
        <ScrollReveal>
          <p className="micro-label text-foreground-400">{initials || '·'}</p>
          <div className="mt-4 flex items-center justify-center gap-3">
            <span className="h-px w-16 bg-primary-300" />
            <span className="h-1.5 w-1.5 rotate-45 bg-primary-400" />
            <span className="h-px w-16 bg-primary-300" />
          </div>
        </ScrollReveal>
      </div>

      <ScrollReveal>
        <div className="relative h-[55vh] w-full sm:h-[65vh] md:h-[75vh]">
          <WeddingImage
            src={weddingImages.photoDivider.src}
            fallback={weddingImages.photoDivider.fallback}
            alt={weddingImages.photoDivider.alt}
            className="h-full w-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-background-50/20 via-transparent to-background-50/30" />
        </div>
      </ScrollReveal>
    </section>
  );
}